import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../common/Button';
import { Container } from '../common/Container';

export const Hero: React.FC = () => {
  const navigate = useNavigate();
  
  const scrollToHowItWorks = () => {
    const element = document.getElementById('how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  return (
    <section className="relative bg-brand-blue overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-brand-red rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-red rounded-full blur-3xl" />
      </div>
      
      <Container className="relative py-24 lg:py-32">
        <div className="max-w-4xl mx-auto text-center">
          {/* Content */}
          <div className="text-white">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white">
              Win Your Property Tax Appeals with{' '}
              <span className="text-brand-red">Data-Driven</span> Expertise
            </h1>
            
            <p className="text-xl text-brand-blue-100 mb-10 leading-relaxed max-w-3xl mx-auto">
              Professional property tax appeal management for residential, 
              commercial, and condominium properties. Streamline your workflow 
              from valuation to victory.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <Button size="lg" onClick={() => navigate('/contact')}>
                Request a Demo
              </Button>
              <Button variant="outline" size="lg" onClick={scrollToHowItWorks}>
                See How It Works
              </Button>
            </div>
            
            {/* Trust Indicators */}
            <div className="pt-8 border-t border-brand-blue-400 max-w-2xl mx-auto">
              <div className="grid grid-cols-2 gap-8">
                <div>
                  <div className="text-3xl font-bold text-white">10K+</div>
                  <div className="text-sm text-brand-blue-100">Properties Managed</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-white">$50M+</div>
                  <div className="text-sm text-brand-blue-100">Tax Savings</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

